import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { withRouter } from "react-router";
import {
    Card,
    Page,
    Text,
    // TextField,
    IndexTable,
    IndexFilters,
    // useSetIndexFiltersMode,
    useIndexResourceState,
    ChoiceList,
    // RangeSlider,
    Badge,
    // useBreakpoints,
    BlockStack,
    Icon,
    Button,
    Tooltip,
    ActionList,
    Popover,
    Modal,
    Pagination,
    Spinner,
    Banner,
    // ProgressBar,
    Checkbox,
    TextField,
} from "@shopify/polaris";
import {
    // BlogMajor,
    CancelMinor,
    DeleteMinor,
    DuplicateMinor,
    EditMinor,
    // ChevronDownMinor,
    ExportMinor,
    ExternalMinor,
    LockMinor,
    RefreshMinor,
    SaveMinor,
    ViewMinor,
} from "@shopify/polaris-icons";
import "./index.scss";
import {
    reqGetKeywordsData,
    reqGetKeywordsListData,
    reqSaveCategory,
    reqUnlockKeywordsPosition,
    reqGetKeywordsWebsite,
    reqGetExportRecord,
    reqExportKeywords,
    reqHandleAIUsagePayment,

} from "../../../api/index";
import Langauge from "../../../i18n/Language";
import AIIcon from "../../../assets/AIIcon";
import FooterPageSelect from "../../../components/FooterPageSelect";
import FooterTrustHelp from "../../../components/FooterTrustHelp";
import utils from "../../../utils/utils";
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { API_OSS } from "../../../utils/constants";
import AddToSegments from "../../../components/AddToSegments";
import { store } from "../../../redux/store";
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Langauge;

const KeywordsData = (props) => {
    const {
        level,

        show,
        toggleToast,
        showEditPageModal,

    } = props;
    const resourceName = {
        singular: "data",
        plural: "datas",
    };

    const testData = [
        { "id": 1, "keyword": "****" },
        { "id": 2, "keyword": "****" },
        { "id": 3, "keyword": "****" },
        { "id": 4, "keyword": "****" },
        { "id": 5, "keyword": "****" },
        { "id": 6, "keyword": "****" },
    ];

    const listRef = useRef();

    const [userLevel, setUserLevel] = useState(1);
    const [notFirstReq, setNotFirstReq] = useState(false);  // 首次请求
    // 分页数据
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [current_PageSize, setCurrentPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [hasNext, setHasNext] = useState(false);
    // 列表数据
    const [tableData, setTableData] = useState([]);
    const [listLoading, setListLoading] = useState(true);
    // const [keywords_ranking_use, setKeywordsRankingUse] = useState(0);
    // const [keywords_ranking_all, setKeywordsRankingAll] = useState(0);
    // const [keywordsRankingPerc, setKeywordsRankingPerc] = useState(0);

    // 顶部模块数据
    const [covered, setCovered] = useState(0);
    const [coveredAll, setCoveredAll] = useState(0);
    const [coveredPerc, setCoveredPerc] = useState(0);
    const [kwTen, setKWTen] = useState(0);
    const [kwTenPerc, setKWTenPerc] = useState(0);
    const [kwFifty, setKWFifty] = useState(0);
    const [kwFiftyPerc, setKWFiftyPerc] = useState(0);
    const [updTime, setUpdTime] = useState(0);

    // 导出记录
    const [exportRecordsData, setExportRecordsData] = useState([]);  // 导出记录
    // 网站数据
    const [websiteArray, setWebsiteArray] = useState([]);

    const [getRecordState, setGetRecordState] = useState(false);  // 导出记录获取状态
    const [recordLoading, setRecordLoading] = useState(false);  // 导出记录状态
    const [exportRecordsState, setExportRecordsState] = useState(false);  // 导出记录弹窗
    const [refreshLoading, setRefreshLoading] = useState(false);  // 刷新状态
    const [exportPopState, setExportPopState] = useState(false);  // 导出弹层
    const [exportLoading, setExportLoading] = useState(false);  // 导出状态
    // const [topicPopState, setTopicPopState] = useState(false);  // Topic弹层
    // const [topicList, setTopicList] = useState([]);  // Topic列表
    // const [topicSel, setTopicSel] = useState({});  // Topic选项
    const [topicSelArr, setTopicSelArr] = useState([]);  // Topic筛选选项
    const [segmentsList, setSegmentsList] = useState([]);  // Segments选项
    const [coveredSelArr, setCoveredSelArr] = useState([]);  // Covered筛选选项
    const [typeSelArr, setTypeSelArr] = useState([]);  // Type筛选选项
    const [segmentsSelArr, setSegmentsSelArr] = useState([]);  // Segments筛选选项
    const [isShowSegDel, setIsShowSegDel] = useState(false);  // Segments删除按钮
    const [openState, setOpenState] = useState(false);  // 添加分类
    const [keywordsSelData, setKeywordsSelData] = useState([]);  // 选择id数组
    const [isShowCategoryModal, setIsShowCategoryModal] = useState(false);  // 分类管理状态

    // 额度
    const [ai_usage_status, setAiUsageStatus] = useState(-1);  // 超额状态
    const [AiPoints, setAiPoints] = useState(0);  // 超额状态
    const [overchargeState, setOverchargeState] = useState(false);  // 超额弹窗
    const [agreeLoading, setAgreeLoading] = useState(false);  // 超额状态
    const [buyAiCreditsState, setBuyAiCreditsState] = useState(false);  // 超额状态
    const [isOneTrial, setIsOneTrial] = useState(false);  // 超额状态
    const [isShowOverchargeTip, setIsShowOverchargeTip] = useState(true);  // 超额状态
    const [writeLoading, setWriteLoading] = useState(-1);  // 超额

    const [writePopState, setWritePopState] = useState(-1);  // 按钮弹层
    const [viewPopState, setViewPopState] = useState(-1);  // view弹层
    const [delSegState, setDelSegState] = useState(false);  // 删除seg弹层
    const [delSegData, setDelSegData] = useState({});  // 删除seg数据
    const [delSegLoading, setDelSegLoading] = useState(false);  // 删除seg 状态
    const [createSegmentState, setCreateSegmentState] = useState(true);  // 创建模式
    const [segmentVal, setSegmentVal] = useState("");  // seg文案
    const [createLoading, setCreateLoading] = useState(false);  // 创建loading
    const [editSegId, setEditSegId] = useState(-1);  // 操作对象
    const [categoryVal, setCategoryVal] = useState('');  // 操作对象

    const [websiteLoading, setWebsiteLoading] = useState(false);  // 获取网站状态
    const [unlockId, setUnlockId] = useState(-1);  // 解锁对象状态
    // const [glassId, setGlassId] = useState(-1);  // icon状态

    // 提示模块
    const [pageTipBanner, setPageTipBanner] = useState({ msg: '', tone: '' });
    const [activeBoxAudit, setActiveBoxAudit] = useState(true);
    const [domainNotResolve, setDomainNotResolve] = useState(false);    // 域名未解析
    const [resolveUrl, setResolveUrl] = useState('');
    const [isGetData, setIsGetData] = useState(false);
    const [isShowTipBanner, setIsShowTipBanner] = useState(true);

    const [selected, setSelected] = useState(0);
    const [queryValue, setQueryValue] = useState("");
    const [sortSelected, setSortSelected] = useState(["data asc"]);
    const [mode, setMode] = useState("DEFAULT"); // DEFAULT || FILTERING 

    // 排序
    const [kdSort, setKdSort] = useState('descending');
    const [volumeSort, setVolumeSort] = useState('descending');
    const [trafficSort, setTrafficSort] = useState('descending');

    const pageRef = useRef(page);
    const sizeRef = useRef(size);
    const sortInxRef = useRef(-1);
    const sortTypeRef = useRef('');
    const coveredSelRef = useRef(coveredSelArr);
    const segmentsSelRef = useRef(segmentsSelArr);
    const typeSelRef = useRef(typeSelArr);
    const keywordSelRef = useRef('');

    // 标题
    const tableHeadings = [
        { id: 1, title: <span>{t("Keyword")}</span> },
        { id: 2, title: <Tooltip content={t("Estimated difficulty of ranking in the top 10 organic search results for this keyword on a 100-point scale")}><span>{t("KD")}</span></Tooltip>, defaultSortDirection: kdSort },
        { id: 3, title: <Tooltip content={t("This keyword has been searched for this time in the past 12 months")}><span>{t("Volume")}</span></Tooltip>, defaultSortDirection: volumeSort },
        { id: 4, title: <Tooltip content={t("An estimation of the number of monthly visitors that your target gets from organic search for a keyword. We base this on the number of searches for that keyword over the latest month.")}><span>{t("Traffic")}</span></Tooltip>, defaultSortDirection: trafficSort },
        { id: 5, title: <span>{t("Position")}</span> },
        { id: 6, title: <span>{t("Action")}</span> },
    ]

    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(tableData);

    // 获取关键词数据
    const getKeywordData = async (cache = null, isJumpBlog = false) => {
        const res = cache || await reqGetKeywordsData();
        if (res.ack === 1) {
            let _t = res.data;
            // let topic = [
            //     { label: 'Enabled', value: 'enabled' },
            //     { label: 'Not invited', value: 'not invited' },
            //     { label: 'Invited', value: 'invited' },
            //     { label: 'Declined', value: 'declined' },
            // ]
            // let newTopicArr = topic.map(i => {
            //     return {
            //         label: i.label,
            //         value: i.value,
            //     }
            // })
            // setTopicList(newTopicArr);
            let newSegmentsArr = (_t.category || []).map(i => {
                return {
                    id: i.id,
                    label: i.name,
                    value: i.id,
                    status: segmentsSelArr.includes(i.id) ? true : false,
                    keyword_count: i.keyword_count,
                }
            })
            setSegmentsList(newSegmentsArr);

            let _c = _t.count;
            setCovered(_c.now.cover_num);
            setCoveredAll(_c.total);
            setKWTen(_c.now.kw_top_10_num);
            setKWFifty(_c.now.kw_top_50_num);
            setCoveredPerc(_c.past.cover_num === 0 ? (_c.now.cover_num === 0 ? 0 : 99) : Number(((_c.now.cover_num - _c.past.cover_num) / _c.past.cover_num) * 100).toFixed(1));
            setKWTenPerc(_c.past.kw_top_10_num === 0 ? (_c.now.kw_top_10_num === 0 ? 0 : 99) : Number(((_c.now.kw_top_10_num - _c.past.kw_top_10_num) / _c.past.kw_top_10_num) * 100).toFixed(1));
            setKWFiftyPerc(_c.past.kw_top_50_num === 0 ? (_c.now.kw_top_50_num === 0 ? 0 : 99) : Number(((_c.now.kw_top_50_num - _c.past.kw_top_50_num) / _c.past.kw_top_50_num) * 100).toFixed(1));

            let _k = _t.my_keyword;
            setResolveUrl(_k.dns_url);
            // setActiveBoxAudit(!Boolean(_k.domain_status));
            setDomainNotResolve(!Boolean(_k.domain_status));
            setIsGetData(Boolean(_k.status));
            setUpdTime(_k.next_updated_at ? utils.formatUSATime(_k.next_updated_at) : 0);

            setAiUsageStatus(_t.ai.ai_usage_status)
            setAiPoints(_t.ai.ai_points)
            try {
                setActiveBoxAudit(!Boolean(sessionStorage.getItem('activeBoxKeyWebsite')));
            } catch (e) { }

            // 是否跳转博客
            setWriteLoading(-1);
            if (isJumpBlog) {
                jumpCreateBlog(-1, '', true);
            }
        } else {
            setTipBanner(res.msg);
        }
    }

    // 获取关键词列表
    const getKeywordsList = async (page, size, query) => {
        setListLoading(true);
        setHasPrevious(false);
        setHasNext(false);
        let params = {
            page,
            size,
            query
        }
        // if (topicSelArr && !isEmpty(topicSelArr)) {
        //     params.topic_id = topicSelArr;
        // }
        // 使用ref缓存
        const currentCoveredSel = coveredSelRef.current;
        const currentSegmentsSel = segmentsSelRef.current;
        const currentTypeSel = typeSelRef.current;
        if (currentCoveredSel && !isEmpty(currentCoveredSel)) {
            params.covg = currentCoveredSel[0] === 'Yes' ? 1 : 0
        }
        if (currentSegmentsSel && !isEmpty(currentSegmentsSel)) {
            params.category_ids = currentSegmentsSel;
        }
        if (currentTypeSel && !isEmpty(currentTypeSel)) {
            params.from = currentTypeSel;
        }
        // 排序
        if (sortInxRef.current !== -1) {
            params.order_by_column = sortInxRef.current;
            params.order_by_direction = sortTypeRef.current;
        }

        const res = await reqGetKeywordsListData(params);
        if (res.ack === 1) {
            let _t = res.data;
            setTableData(_t.data);
            setTotal(_t.count);
            setHasPrevious(page > 1);
            setHasNext((page * size) < _t.count);
            setListLoading(false);
            // 等级额度
            // setKeywordsRankingUse(_t.quota.keywords_ranking_use);
            // setKeywordsRankingAll(_t.quota.keywords_ranking_all);
            // let perc = (_t.quota.keywords_ranking_use / _t.quota.keywords_ranking_all) > 1 ? 100 : Number(((_t.quota.keywords_ranking_use / _t.quota.keywords_ranking_all) * 100).toFixed(0));
            // setKeywordsRankingPerc(perc);

        } else {
            setTipBanner(res.msg);
        }
    }
    const debouncedGetKeywordsList = useMemo(() => debounce((value) => {
        getKeywordsList(pageRef.current, sizeRef.current, value);
    }, 300), [getKeywordsList]); // 300ms 可根据需求调整

    // Topic筛选
    // const handleTopicChange = useCallback(
    //     (value) => setTopicSelArr(value),
    //     [],
    // );

    // Covered筛选
    const handleCoveredChange = useCallback(
        (value) => setCoveredSelArr(value),
        [],
    );

    // Segments筛选
    const handleSegmenstChange = (value) => {
        let newSelArr = cloneDeep(segmentsSelArr);
        let newList = cloneDeep(segmentsList);
        if (newSelArr.indexOf(value) > -1) {
            newSelArr.splice(newSelArr.indexOf(value), 1);
        } else {
            newSelArr.push(value);
        }
        newList.forEach(i => {
            if (i.value === value) {
                i.status = !i.status;
            }
        })
        setSegmentsSelArr(newSelArr);
        setSegmentsList(newList);
    }

    // 类型筛选
    const handleTypeChange = (value) => {
        setTypeSelArr(value)
    }

    // 管理segments
    const handleManageSegments = () => {
        // setIsShowSegDel(!isShowSegDel);
        setIsShowCategoryModal(true);
    }

    // 打开弹窗
    const handleOpenDelSegment = (data) => {
        setDelSegState(true);
        setDelSegData(data);
    }

    // 删除筛选条件
    const handleTopicRemove = () => {
        setTopicSelArr([]);
    }
    const handleCoveredRemove = () => {
        setCoveredSelArr([]);
    }
    const handleSegmentsRemove = () => {
        setSegmentsSelArr([]);
    }
    const handleTypeRemove = () => {
        setTypeSelArr([])
    }

    // 过滤条件    
    const CoveredList = [
        { label: t("Yes"), value: 'Yes' },
        { label: t("No"), value: 'No' },
    ]
    const TypeList = [
        { label: t("Organic keywords"), value: 1 },
        { label: t("Paid keywords"), value: 2 },
    ]
    const filters = [
        // {
        //     key: 'Topic',
        //     label: t("Topic"),
        //     filter: (
        //         <ChoiceList
        //             title={t("Topic")}
        //             titleHidden
        //             choices={topicList}
        //             selected={topicSelArr || []}
        //             onChange={handleTopicChange}
        //             allowMultiple
        //         />
        //     ),
        //     pinned: true,
        // },
        {
            key: 'Covered',
            label: t("Covered"),
            filter: (
                <ChoiceList
                    title={t("Covered")}
                    titleHidden
                    choices={CoveredList}
                    selected={coveredSelArr || []}
                    onChange={handleCoveredChange}
                />
            ),
            pinned: true,
        },
        {
            key: 'Segments',
            label: t("Categories"),
            filter: (
                <div className="Segments_filter">
                    {/* <ChoiceList
                        title={t("Segments")}
                        titleHidden
                        choices={segmentsList}
                        selected={segmentsSelArr || []}
                        onChange={handleSegmenstChange}
                        allowMultiple
                    /> */}
                    {
                        segmentsList.map(seg => {
                            return <div className="flex_layout" key={seg.value} style={{ justifyContent: 'space-between' }}>
                                <Checkbox
                                    label={seg.label}
                                    checked={segmentsSelArr.includes(seg.value)}
                                    onChange={() => handleSegmenstChange(seg.value)}
                                />
                                {
                                    isShowSegDel && <span className="seg_delete" onClick={() => handleOpenDelSegment(seg)}><Icon source={CancelMinor} tone="base" /></span>
                                }
                            </div>
                        })
                    }
                    <Button variant="plain" disabled={segmentsList.length === 0} onClick={handleManageSegments}>
                        <span className="manage_cag">{t("Manage categories")}</span>
                    </Button>
                </div>
            ),
            pinned: true,
        },
        {
            key: 'Type',
            label: t("Type"),
            filter: (
                <ChoiceList
                    title={t("Type")}
                    titleHidden
                    choices={TypeList}
                    selected={typeSelArr || []}
                    onChange={handleTypeChange}
                    allowMultiple
                />
            ),
            pinned: true,
        }
    ];
    const appliedFilters = [];
    // if (topicSelArr && !isEmpty(topicSelArr)) {
    //     const key = 'Topic';
    //     appliedFilters.push({
    //         key: key,
    //         label: disambiguateLabel(key, topicSelArr, topicList),
    //         onRemove: handleTopicRemove,
    //     })

    // }
    if (coveredSelArr && !isEmpty(coveredSelArr)) {
        const key = 'Covered';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, coveredSelArr, CoveredList),
            onRemove: handleCoveredRemove,
        })
    }
    if (segmentsSelArr && !isEmpty(segmentsSelArr)) {
        const key = 'Segments';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, segmentsSelArr, segmentsList),
            onRemove: handleSegmentsRemove,
        })
    }
    if (typeSelArr && !isEmpty(typeSelArr)) {
        const key = 'Type';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, typeSelArr, TypeList),
            onRemove: handleTypeRemove,
        })
    }

    // 打开添加
    const handleOpenAddSegments = () => {
        if (userLevel !== 3) {
            show(2);
        } else {
            setOpenState(true);
            setKeywordsSelData(selectedResources);
        }
    }

    // 批量
    const promotedBulkActions = [
        {
            content: t("Add to categories"),
            onAction: () => handleOpenAddSegments(),
        }
    ];

    // 取消
    const onHandleCancel = () => {
        if (queryValue || topicSelArr.length > 0 || coveredSelArr.length > 0 || segmentsSelArr.length > 0) {
            handleFiltersClearAll();
        }
    };
    const onCreateNewView = async (value) => {
        return value;
    };
    const handleFiltersQueryChange = useCallback((value) => {
        setQueryValue(value);
        debouncedGetKeywordsList(value);
    }, []);

    // 清除过滤条件
    const handleFiltersClearAll = useCallback(() => {
        handleFiltersQueryChange("");
        handleTopicRemove();
        handleCoveredRemove();
        handleSegmentsRemove();
        handleTypeRemove();
    }, [
        handleFiltersQueryChange,
        handleTopicRemove,
        handleCoveredRemove,
        handleSegmentsRemove,
        handleTypeRemove,
    ]);

    // 跳转链接
    const jumpUrl = (url) => {
        props.history.push(url);
    }

    // 查看链接
    const handleViewUrl = (e, id, keyword, num) => {
        e && e.stopPropagation();
        getKeywordsWebsiteData(id, keyword, num);
    }

    // 获取网站
    const getKeywordsWebsiteData = async (id, keyword, num) => {
        setWebsiteLoading(id);
        let params = {
            keyword_id: id,
            keyword,
        }
        const res = await reqGetKeywordsWebsite(params);
        if (res.ack === 1) {
            setWebsiteArray(res.data);
            // setViewPopState(id);
            if (num > 1) {
                setViewPopState(id);
            } else {
                window.open(res.data[0].website);
            }
        } else {
            toggleToast(t(res.msg), true);
        }
        setWebsiteLoading(-1);
    }

    // 切换页数
    const changePageSize = (s) => {
        setPage(1);
        setSize(s);
        setCurrentPageSize(s);
        getKeywordsList(1, s, queryValue);
    }

    // 分页
    const changePageTable = (p) => {
        setPage(p);
        getKeywordsList(p, size, queryValue);
    }

    // 关闭弹窗seg
    const handleCancelDelSeg = () => {
        setDelSegState(false);
    }

    // 跳转创建博客
    const jumpCreateBlog = (id, val, isVerify = false) => {
        // 缓存值
        if (val) {
            keywordSelRef.current = val;
        }
        setWritePopState(-1);
        // 判断积分是否足够
        if (AiPoints >= 20 || isVerify) {
            // shopify 内嵌模式
            const isShopify = window.shopify;
            const url = "/on-page-seo/generate-blog";
            if (isShopify) {
                showEditPageModal(url, "OnpageBlog_Modal", null, { keyword: keywordSelRef.current, jumptype: 'keywords' });
            } else {
                let path = {
                    pathname: url,
                    query: {
                        keyword: keywordSelRef.current,
                        jumptype: 'keywords'
                    }
                }
                props.history.push(path);
            }
        } else {
            if (userLevel !== 1 && [30002, 30003, 40002].includes(ai_usage_status)) {
                setOverchargeState(20);
            } else if (ai_usage_status === true) {
                setWriteLoading(id);
                handleOverchargeState(true, 20);
            } else if (userLevel === 3) {
                handleBuyAiCreditsState(true);
            } else {
                show(userLevel < 2 ? 1 : 2, true);
            }
        }
    }

    // 超额操作
    const handleOverchargeState = async (state, defalutPoints = 0) => {
        if (((!Boolean(overchargeState) && Boolean(state)) || !Boolean(state)) && !Boolean(defalutPoints)) {
            setOverchargeState(state);
        } else {
            setAgreeLoading(true);
            let params = {
                points: defalutPoints > 0 ? defalutPoints : overchargeState
            }
            const res = await reqHandleAIUsagePayment(params);
            if (res.ack === 1) {
                toggleToast(t(res.msg));
                setOverchargeState(false);
                getKeywordData(null, true);
            } else {
                toggleToast(t(res.msg), true);
            }

            if (res) {
                setAgreeLoading(false);
            }
        }
    }

    // 购买积分提示
    const handleBuyAiCreditsState = (_state) => {
        setBuyAiCreditsState(_state)
    }

    // 跳转购买积分
    const jumpPricingCreditsBuy = () => {
        let paths = {
            pathname: '/plan',
            query: "pay_credits",
        }
        props.history.push(paths)
    }

    // 跳转设置页
    const jumpSettingPage = () => {
        let paths = {
            pathname: '/settings',
            query: "overcharge",
        }
        props.history.push(paths)
    }

    // 关闭提示
    const closeOverchargeTip = () => {
        setIsShowOverchargeTip(false);
        try {
            sessionStorage.setItem("overcharge_onpage", "close");
        } catch (e) { }
    }

    // 导出记录
    const exportKeywordsData = async () => {
        if (userLevel !== 3) {
            show(2)
        } else {
            setExportPopState(false);
            setExportLoading(true);
            const currentCoveredSel = coveredSelRef.current;
            const currentSegmentsSel = segmentsSelRef.current;
            const currentTypeSel = typeSelRef.current;
            let params = {
                query: queryValue,
            }
            if (currentCoveredSel && !isEmpty(currentCoveredSel)) {
                params.covg = currentCoveredSel[0] === 'Yes' ? 1 : 0
            }
            if (currentSegmentsSel && !isEmpty(currentSegmentsSel)) {
                params.category_ids = currentSegmentsSel;
            }
            if (currentTypeSel && !isEmpty(currentTypeSel)) {
                params.from = currentTypeSel;
            }
            const res = await reqExportKeywords(params);
            if (res.ack === 1) {
                setTimeout(() => {
                    openExportHistory(true);
                    setExportLoading(false);
                }, 500)
            } else {
                toggleToast(t(res.msg), true);
                setExportLoading(false);
            }
        }
    }

    // 打开导出记录
    const openExportHistory = (isReq = false) => {
        setExportPopState(!exportPopState);
        setExportRecordsState(true);
        setRecordLoading(true);
        if (!getRecordState || isReq) {
            getExportRecordData();
        } else {
            setRecordLoading(false);
        }
    }

    // 获取记录
    const getExportRecordData = async () => {
        const res = await reqGetExportRecord();
        if (res.ack === 1) {
            setGetRecordState(true);
            setExportRecordsData(res.data);
            setRecordLoading(false);
            setRefreshLoading(false);
        } else {
            toggleToast(t(res.msg), true);
        }
    }

    // 选择话题
    // const handleSelectTopic = (data) => {
    //     setTopicSel(data);
    // }

    // 刷新
    const refreshExportRecord = () => {
        setRefreshLoading(true);
        getExportRecordData();
    }

    // 设置提示banner
    const setTipBanner = (msg, tone = 'critical') => {
        setPageTipBanner({ msg, tone });
    }

    //点击联系客服
    const handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭密码
    const closeDomainBannerObj = () => {
        setActiveBoxAudit(false);
        try {
            sessionStorage.setItem('activeBoxKeyWebsite', 'close')
        } catch (e) { }
    }

    // 关闭banner
    const closeTipBanner = () => {
        // isShowTipBanner: false,
        try {
            sessionStorage.setItem('isShowTipBannerMywebsite', 'close');
        } catch (e) {
            console.log(e)
        }
    }

    // 解锁排名
    const handleUnlockPosition = async (e, id) => {
        e && e.stopPropagation();
        setUnlockId(id);
        let params = {
            keyword_ids: [id],
        }
        const res = await reqUnlockKeywordsPosition(params);
        if (res.ack === 1) {
            getKeywordsList(page, size, queryValue);
        } else {
            setTipBanner(res.msg);
        }
        setUnlockId(-1);
        // setGlassId(-1);
    }

    // 删除segmenet
    const handleDelSegments = () => {
        let newList = cloneDeep(segmentsList);
        let _index = -1;
        segmentsList.find((d, i) => {
            if (d.value === delSegData.value) {
                _index = i;
            }
        });
        newList.splice(_index, 1)
        submitUpdSegments(newList, 'del');
    }

    // 提交数据
    const submitUpdSegments = async (data, type = 'save') => {
        setCreateLoading(true);
        setDelSegLoading(true);
        let params = {
            category: data.map(d => {
                return {
                    id: d.value,
                    name: d.label
                }
            })
        };
        const res = await reqSaveCategory(params);
        if (res.ack === 1) {
            toggleToast(type === 'save' ? t("Saved") : t("Deleted"));
            setDelSegState(false);
            setSegmentsList(data);
            let _statusArr = [];
            data.forEach(d => {
                if (d.states) {
                    _statusArr.push(d.value);
                }
            })
            setDelSegData({});
            setSegmentsSelArr(_statusArr)
            setSegmentVal("");
            setCreateSegmentState(true);
            setEditSegId(-1);
        } else {
            toggleToast(t(res.msg), true);
        }
        setCreateLoading(false);
        setDelSegLoading(false);
    }

    // 关闭创建弹窗
    const handleCloseCreateModal = () => {
        setOpenState(false);
    }

    // 重置参数
    const handleResetAll = () => {
        clearSelection();
        getKeywordsList(page, size, queryValue);
    }

    // 更新segments列表
    const handleCallbackData = (data) => {
        getKeywordData(data);
    }

    // 排序
    const onSortColumnData = (e, v) => {
        if (e === 1) {
            setKdSort(v === 'descending' ? 'ascending' : 'descending');
        } else if (e === 2) {
            setVolumeSort(v === 'descending' ? 'ascending' : 'descending');
        } else if (e === 3) {
            setTrafficSort(v === 'descending' ? 'ascending' : 'descending');
        } else { }
        sortInxRef.current = e === 1 ? 'kd' : e === 2 ? 'volume' : 'traffic';
        sortTypeRef.current = v === 'descending' ? 'asc' : 'desc';
        getKeywordsList(page, size, queryValue)
    }

    // 关闭弹窗
    const handleCloseManageModal = () => {
        setIsShowCategoryModal(false);
    }

    // 切换创建
    const handleCreateSegment = () => {
        setCreateSegmentState(!createSegmentState);
    }

    // 输入
    const handleSegmentValChange = (v) => {
        setSegmentVal(v)
    }

    // 失焦
    const blurSegmentChange = () => {
        if (!segmentVal) {
            setCreateSegmentState(true);
        }
    }

    // 创建segmenet
    const handleCreateSegments = () => {
        let newList = cloneDeep(segmentsList);
        newList.push({
            id: 0,
            value: 0,
            label: segmentVal,
            keyword_count: 0,
        })
        submitUpdSegments(newList);
    }

    // 编辑关键词
    const handleEditSegment = (obj) => {
        setCategoryVal(obj.label);
        setEditSegId(obj.id);
    }

    // 失焦保存
    const handleBlurEditSeg = (id) => {
        let newList = cloneDeep(segmentsList);
        let isChange = false;
        newList.forEach(item => {
            if (item.id === id && item.label !== categoryVal && categoryVal) {
                item.label = categoryVal;
                isChange = true;
            }
        })
        if (isChange) {
            submitUpdSegments(newList);
        } else {
            setEditSegId(-1);
        }
    }

    // 输入
    const handleChangeCategory = (v) => {
        setCategoryVal(v);
    }

    // 保存分类选择
    const saveSegmentsSet = async () => {
        if (userLevel !== 3) {
            show(2);
        } else {
            setSaveLoading(true);
            let params = {
                category_ids: segmentsSelArr,
            };
            if (type === "Keywords") {
                params.keyword_ids = keywordsSelData;
            } else {
                params.keywords = keywordsSelData;
                params.from = 4;
            }
            let res = {};
            if (type === "Keywords") {
                res = await reqAddToKeywordCategory(params);
            } else {
                res = await reqAddOnPageKeyword(params);
            }
            if (res.ack === 1) {
                toggleToast(t("Saved"))
                setCreateSegmentState(true);
                setSegmentVal("");
                setSegmentsSelArr([]);
                handleCloseModal();
                if (type === "Keywords") {
                    handleResetAll();
                } else {
                    handleUpdCollect();
                }
            } else {
                toggleToast(res.msg, true);
            }
            setSaveLoading(false);
        }
    }

    // 在组件卸载时清除定时器，防止内存泄漏
    useEffect(() => {
        return () => {
            debouncedGetKeywordsList.cancel();
        };
    }, [debouncedGetKeywordsList]);

    // 监听表格行触摸
    // useEffect(() => {
    //     const parent = listRef.current;
    //     if (!parent) return;
    //     const handleMouseEnter = (e) => {
    //         const target = e.target;
    //         const row = target.closest(".Polaris-IndexTable__TableRow");
    //         if (row && tableData.length > 0) {
    //             const index = Array.prototype.indexOf.call(row.parentNode?.children, row);
    //             if (index >= 0 && tableData[index]) {
    //                 setGlassId(tableData[index].id);
    //             }
    //         }
    //     };

    //     const handleMouseLeave = () => {
    //         setGlassId(-1);
    //     };

    //     parent.addEventListener("mouseover", handleMouseEnter);
    //     parent.addEventListener("mouseout", handleMouseLeave);

    //     return () => {
    //         parent.removeEventListener("mouseover", handleMouseEnter);
    //         parent.removeEventListener("mouseout", handleMouseLeave);
    //     };
    // }, [tableData, listRef])

    // 是否隐藏弹层
    useEffect(() => {
        let objs = document.querySelectorAll('.Polaris-Popover__PopoverOverlay--open');
        if (objs && objs.length > 0) {
            objs.forEach(item => {
                // item.style.opacity = (delSegState || exportRecordsState || isShowCategoryModal) ? 0 : 1;
                item.style.zIndex = (delSegState || exportRecordsState || isShowCategoryModal) ? -1 : 2147483003;
            })
        }
    }, [delSegState, exportRecordsState, isShowCategoryModal])

    // 针对列表数据变化情况筛选
    useEffect(() => {
        pageRef.current = page;
        sizeRef.current = size;
        clearSelection();
    }, [page, size, queryValue])

    // 筛选条件更新列表
    useEffect(() => {
        clearSelection();
        coveredSelRef.current = coveredSelArr;
        segmentsSelRef.current = segmentsSelArr;
        typeSelRef.current = typeSelArr;
        if (notFirstReq) {
            setPage(1);
            pageRef.current = 1;
            getKeywordsList(1, size, queryValue);
        }
    }, [coveredSelArr, segmentsSelArr, typeSelArr])
    // topicSelArr,

    // 设置等级
    useEffect(() => {
        setUserLevel(level);
    }, [level])

    useEffect(() => {
        // 浏览器缓存
        try {
            let states = sessionStorage.getItem('isShowTipBannerMywebsite');
            setIsShowTipBanner(!Boolean(states));
            let currentTime = (new Date().getTime()) / 1000;
            setIsOneTrial(store.getState().public.publicInit?.meal_data?.trial_ends_on > currentTime);
            let overchargeTip = !Boolean(sessionStorage.getItem("overcharge_onpage"));
            setIsShowOverchargeTip(overchargeTip);
        } catch (e) { }
        // 设置首次请求
        setNotFirstReq(true);
        // 获取数据
        getKeywordData();
        // 获取列表
        getKeywordsList(page, size, queryValue);
    }, [])

    // 错误警告banner
    const PageTipBanner = Boolean(pageTipBanner.msg) && <Banner
        tone={pageTipBanner.tone}
        title={pageTipBanner.msg}
        onDismiss={() => {
            setPageTipBanner({ msg: '', tone: '' });
        }}
        action={{
            content: t("Contact us"),
            onAction: handleContactService
        }}
    ></Banner>

    // 域名解析
    const domainBanner = (activeBoxAudit && domainNotResolve) && <div className='user_mes_status' id='exchangePwd'>
        <Banner title={t("Domain Setup Required")} tone="warning" onDismiss={() => closeDomainBannerObj()}
        >
            <p className='Polaris-Heading'>{t("Complete your")}
                <span onClick={() => {
                    window.open(resolveUrl)
                }} className="jump_text">&nbsp;{t("Shopify domain setup")}&nbsp;</span>
                {t("to unlock website keyword tracking features (required for non-myshopify.com URLs).")}
            </p>
        </Banner>
    </div>
    // 时间提示banner
    const isGetDataLoading = (userLevel > 1 && isShowTipBanner && (!Boolean(queryValue) && topicSelArr.length === 0 && coveredSelArr.length === 0 && segmentsSelArr.length === 0 && typeSelArr.length === 0) && (!isGetData && tableData.length === 0 && !listLoading));
    const TipBanner = isGetDataLoading && <Banner title={
        <div className='flex_layout' style={{ minHeight: '25px' }}>
            <p>{t("We are currently in the process of data extraction. Due to the large volume of data, the processing time may be longer.Please be patient, and we will ensure that the data extraction is completed within 24 hours.")}</p>
            <img src='/face/PartyingFace.png' alt='Partying Face' />
            <span className='audit_tip_loading'>
                <Spinner size='small' />
            </span>
        </div>
    }
        onDismiss={closeTipBanner}
    >
    </Banner>

    // 分类管理
    const categoryManageModal = <Modal
        title={t("Manage categories")}
        open={isShowCategoryModal && !delSegState}
        secondaryActions={[
            {
                content: t("Close"),
                disabled: !createSegmentState,
                onAction: handleCloseManageModal,
            }
        ]}
        onClose={handleCloseManageModal}
    >
        <Modal.Section>
            <IndexTable
                resourceName={{
                    singular: t("category"),
                    plural: t("categories"),
                }}
                itemCount={segmentsList.length}
                selectedItemsCount={0}
                onSelectionChange={handleSelectionChange}
                headings={[
                    { title: t("Categories") },
                    { title: t("Keywords") },
                    { title: t("Action") },
                ]}
                selectable={false}
            >
                {
                    segmentsList.map(({ id, label, keyword_count }, index) => {
                        return <IndexTable.Row
                            id={id}
                            key={id}
                            position={index}
                        >
                            <IndexTable.Cell>
                                {
                                    editSegId === id ? <TextField
                                        value={categoryVal}
                                        focused={true}
                                        onChange={handleChangeCategory}
                                        onBlur={() => handleBlurEditSeg(id)}
                                        disabled={createLoading}
                                        suffix={createLoading ? <span className="edit_segment_suffix"><Spinner size="small" /></span> : null}
                                    /> :
                                        <div className="category_text">
                                            <Text variant="bodyMd" fontWeight="bold" as="p">{label}</Text>
                                        </div>
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>{keyword_count}</IndexTable.Cell>
                            <IndexTable.Cell>
                                <div className="flex_layout" style={{ gap: '1em' }}>
                                    <Button icon={EditMinor} onClick={() => handleEditSegment({ id, label, keyword_count })}></Button>
                                    <Button icon={DeleteMinor} onClick={() => handleOpenDelSegment({ id, label, keyword_count })}></Button>
                                </div>
                            </IndexTable.Cell>
                        </IndexTable.Row>
                    })
                }
            </IndexTable>
            <div className="opera_segment">
                {
                    createSegmentState ? <div className="create_segment flex_layout" onClick={handleCreateSegment}>
                        <span><Icon source={DuplicateMinor} tone="base" /></span>
                        <Button variant="plain">{t("Create new category")}</Button>
                    </div> : <div className="flex_layout">
                        <TextField
                            value={segmentVal}
                            onChange={handleSegmentValChange}
                            onBlur={blurSegmentChange}
                            focused={true}
                        />
                        <Button variant="primary" loading={createLoading} onClick={handleCreateSegments}>{t("Save")}</Button>
                    </div>
                }
            </div>
        </Modal.Section>
    </Modal>

    // 删除提示弹窗
    const delSegmentsModal = <Modal
        open={delSegState}
        title={t("Delete confirm")}
        primaryAction={{
            content: t("Delete"),
            onAction: handleDelSegments,
            loading: delSegLoading
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: handleCancelDelSeg,
                disabled: delSegLoading
            }
        ]}
        onClose={handleCancelDelSeg}
    >
        <Modal.Section>
            <p>{t("This segment will be permanently removed. Your keywords will remain but no longer be categorized under it.")}</p>
        </Modal.Section>
    </Modal>

    // 提示开超额弹窗
    const overchargeModal = <Modal
        open={Boolean(overchargeState)}
        title={t("Terms agreement")}
        primaryAction={{
            content: t("I agree"),
            onAction: () => handleOverchargeState(20, 0),
            loading: agreeLoading,
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleOverchargeState(false, 0),
                disabled: agreeLoading,
            }
        ]}
        onClose={() => handleOverchargeState(false, 0)}
    >
        <Modal.Section>
            <BlockStack gap={200}>
                {
                    (isOneTrial && isShowOverchargeTip) && <Banner
                        title={t("By enabling Add-on Overcharge, you confirm that all add-on fees during your trial period are non-refundable.")}
                        tone='warning'
                        onDismiss={closeOverchargeTip}
                    ></Banner>
                }
                <p>{t("Your AI credits are exhausted. We’ll automatically add 100 AI credits for $9.99 to continue service when your balance hits zero. You can cancel it anytime")}
                    &nbsp;<span onClick={() => jumpSettingPage()} style={{ color: '#005BD3', cursor: 'pointer' }}>{t("here")}</span>.
                </p>
            </BlockStack>
        </Modal.Section>
    </Modal>

    // 积分不足提示
    const creditsBuyModal = <Modal
        open={buyAiCreditsState}
        title={t("AI Credit Reminder")}
        primaryAction={{
            content: t("Purchase AI Credits"),
            onAction: () => jumpPricingCreditsBuy()
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleBuyAiCreditsState(false)
            }
        ]}
        onClose={() => handleBuyAiCreditsState(false)}
    >
        <Modal.Section>
            <p>{t("Your AI credit balance is insufficient")}</p>
        </Modal.Section>
    </Modal>

    // 导出记录弹窗
    const rowExportData = exportRecordsData.map(
        (
            { id, name, count, export_at, status, is_del }, index
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                position={index}
            >
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="p">{name}</Text>
                </IndexTable.Cell>
                <IndexTable.Cell>{count}</IndexTable.Cell>
                <IndexTable.Cell>{utils.timeFormat(export_at)}</IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        is_del === 1 ? <Badge tone="critical">{t("Expired")}</Badge> : status === 0 ? <Badge tone="info" progress="incomplete">{t("Exporting")}</Badge> : <Badge tone="success" progress="complete">{t("Completed")}</Badge>
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <Button disabled={(status === 0) || (is_del === 1)} icon={SaveMinor} onClick={() => {
                        window.open(`${API_OSS}/export/Keywords/${name}?v=110`)
                    }}>
                    </Button>
                </IndexTable.Cell>
            </IndexTable.Row>
        )
    )
    const exportRecordsModal = <Modal
        open={exportRecordsState}
        title={t("Export records")}
        secondaryActions={[
            {
                content: t("Refresh"),
                onAction: refreshExportRecord,
                loading: refreshLoading
            },
            {
                content: t("Close"),
                onAction: () => setExportRecordsState(false)
            }
        ]}
        onClose={() => {
            setExportRecordsState(false);
        }}
    >
        <Modal.Section>
            {
                recordLoading ? <div className="loading_box"><Spinner size="small" /></div> :
                    <IndexTable
                        resourceName={resourceName}
                        itemCount={exportRecordsData.length}
                        headings={[
                            { title: t("File name") },
                            { title: t("Records number") },
                            { title: t("Export time") },
                            { title: t("Status") },
                            { title: "" },
                        ]}
                        promotedBulkActions={promotedBulkActions}
                        selectable={false}
                    >
                        {rowExportData}
                    </IndexTable>
            }
        </Modal.Section>
    </Modal>

    // 顶部数据模块
    const upIcon = <svg width="8" height="8" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.583829 6.41608C0.398001 6.23025 0.398001 5.92896 0.583829 5.74313L4.93088 1.39608L2.49053 1.3962C2.22773 1.39622 2.01468 1.18318 2.01466 0.920384C2.01465 0.657582 2.22768 0.444529 2.49048 0.444516L6.0797 0.444336C6.20591 0.44433 6.32695 0.494463 6.4162 0.583707C6.50544 0.672951 6.55558 0.793994 6.55557 0.920204L6.55539 4.50942C6.55538 4.77222 6.34232 4.98526 6.07952 4.98524C5.81672 4.98523 5.60369 4.77218 5.6037 4.50937L5.60382 2.06903L1.25677 6.41608C1.07095 6.6019 0.769658 6.6019 0.583829 6.41608Z" fill="#29CC6A" />
    </svg>
    const downIcon = <svg width="8" height="8" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M1.0838 0.583707C1.26963 0.397879 1.57092 0.397879 1.75675 0.583707L6.1038 4.93076L6.10367 2.49041C6.10366 2.22761 6.31669 2.01455 6.57949 2.01454C6.8423 2.01453 7.05535 2.22756 7.05536 2.49036L7.05554 6.07958C7.05555 6.20579 7.00541 6.32683 6.91617 6.41608C6.82693 6.50532 6.70588 6.55545 6.57967 6.55545L2.99046 6.55527C2.72765 6.55525 2.51462 6.3422 2.51464 6.0794C2.51465 5.8166 2.7277 5.60357 2.9905 5.60358L5.43085 5.6037L1.0838 1.25665C0.897974 1.07082 0.897974 0.769536 1.0838 0.583707Z" fill="#B5B5B5" />
    </svg>

    const TopDataBlock = <div className="keyword_top_block">
        <Card padding={300}>
            <Tooltip content={t("The number of keywords you've covered")}>
                <Text variant="headingMd" as="h2">{t("Covered")}</Text>
            </Tooltip>
            <div className="keyword_data">
                {/* domainNotResolve ? '-' :  */}
                {/* && !domainNotResolve */}
                <p>{userLevel === 1 ? '-' : t("{{v1}} of {{v2}}", covered, coveredAll)}</p>
                {(coveredPerc !== 0 && userLevel !== 1) ? <span className={coveredPerc > 0 ? "up_keyword" : "down_keyword"}>
                    {coveredPerc > 0 ? upIcon : downIcon}
                    {
                        coveredPerc === 99 ? <span>+{covered}</span> : <span>{`${coveredPerc}%`}</span>
                    }
                </span> : null}
            </div>
        </Card>
        <Card padding={300}>
            <Tooltip content={t("The number of keywords for which your content ranks in the top 10 positions on search engines.")}>
                <Text variant="headingMd" as="h2">{t("KW IN TOP 10")}</Text>
            </Tooltip>
            <div className="keyword_data">
                {/* domainNotResolve ? '-' :  */}
                {/* && !domainNotResolve */}
                <p>{userLevel === 1 ? '-' : kwTen}</p>
                {(kwTenPerc !== 0 && userLevel !== 1) ? <span className={kwTenPerc > 0 ? "up_keyword" : "down_keyword"}>
                    {kwTenPerc > 0 ? upIcon : downIcon}
                    {
                        kwTenPerc === 99 ? <span>+{kwTen}</span> : <span>{`${kwTenPerc}%`}</span>
                    }
                </span> : null}
            </div>
        </Card>
        <Card padding={300}>
            <Tooltip content={t("The number of keywords for which your content ranks in the top 50 positions on search engines.")}>
                <Text variant="headingMd" as="h2">{t("KW IN TOP 50")}</Text>
            </Tooltip>
            <div className="keyword_data">
                {/* domainNotResolve ? '-' :  */}
                {/* && !domainNotResolve */}
                <p>{userLevel === 1 ? '-' : kwFifty}</p>
                {(kwFiftyPerc !== 0 && userLevel !== 1) ? <span className={kwFiftyPerc > 0 ? "up_keyword" : "down_keyword"}>
                    {kwFiftyPerc > 0 ? upIcon : downIcon}
                    {
                        kwFiftyPerc === 99 ? <span>+{kwFifty}</span> : <span>{`${kwFiftyPerc}%`}</span>
                    }
                </span> : null}
            </div>
        </Card>
        <Card padding={300}>
            <Text variant="headingMd" as="h3">{t("Next update time")}</Text>
            <div className="keyword_data">
                {userLevel === 1 ? '-' : (updTime || '-')}
            </div>
        </Card>
    </div>

    // 测试数据
    const testRowData = testData.map(
        (
            { id, keyword },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={false}
                position={index}
            >
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="p">{keyword}</Text>
                </IndexTable.Cell>
                <IndexTable.Cell>0</IndexTable.Cell>
                <IndexTable.Cell>0</IndexTable.Cell>
                <IndexTable.Cell>0</IndexTable.Cell>
                <IndexTable.Cell>0</IndexTable.Cell>
                <IndexTable.Cell>
                    <Button icon={ViewMinor} disabled>{t("View")}</Button>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    // 关键词列表内容
    const rowKeywordData = tableData.map(
        (
            { id, keyword, kd, volume, traffic, position, website_count },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
            >
                <IndexTable.Cell>
                    <div className="keyword_text">
                        <Text variant="bodyMd" fontWeight="bold" as="p">{userLevel === 1 ? '****' : keyword}</Text>
                        {
                            Boolean(Number(website_count) > 0) ? <div><Badge tone="success">{t("Covered")}</Badge></div> : null
                        }
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div className="ScoreItem">
                        <span className={`${kd <= 40 ? 'ScoreItemGreen' : kd <= 70 ? 'ScoreItemOrange' : 'ScoreItemRed'}`}>{formatNumber(kd)}</span>
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>{formatNumber(volume)}</IndexTable.Cell>
                <IndexTable.Cell>{formatNumber(traffic)}</IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(Number(website_count) > 0) ?
                            <div className="keyword_position_info">
                                {/* {
                                    (Number(unlocking_count) === 0 && Number(unlocked_count) === 0) && <div className="glass_data">
                                        {
                                            (Boolean(glassId === id) || Boolean(unlockId === id)) && <Button icon={LockMinor} onClick={(e) => handleUnlockPosition(e, id)} loading={Boolean(unlockId === id)} disabled={unlockId !== -1}></Button>
                                        }
                                    </div>
                                } */}
                                {
                                    <div className="keyword_position flex_layout">
                                        <span>{position}</span>
                                        {
                                            Boolean(unlockId === id) ? <span><Spinner size="small" /></span> : <span className="kp_action" onClick={(e) => handleUnlockPosition(e, id)}><Icon source={RefreshMinor} tone="base" /></span>
                                        }
                                    </div>
                                }
                            </div> : null
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(Number(website_count) > 0) ? <Popover
                            active={viewPopState === id && websiteLoading === -1}
                            activator={<Button icon={ViewMinor} disabled={userLevel === 1} onClick={(e) => handleViewUrl(e, id, keyword, Number(website_count))} loading={websiteLoading === id}>{t("View")}</Button>}
                            onClose={() => setViewPopState(-1)}
                            preferredAlignment="right"
                        >
                            <Card padding={200}>
                                <div className="keyword_website">
                                    {
                                        websiteArray.map((uitem, uindex) => {
                                            return <div key={uitem.website + uindex} className="keyword_url_item" onClick={(e) => {
                                                e && e.stopPropagation();
                                                window.open(uitem.website);
                                            }}>
                                                <span>{uitem.website}</span>
                                                <Icon source={ExternalMinor} tone="base" />
                                            </div>
                                        })
                                    }
                                </div>
                            </Card>
                        </Popover> : <Popover
                            active={writePopState === id}
                            activator={<Button loading={writeLoading === id} disabled={writeLoading !== -1 || userLevel === 1} onClick={(e) => {
                                e && e.stopPropagation();
                                setWritePopState((writePopState === -1 || writePopState !== id) ? id : -1);
                            }} disclosure>
                                <div className="write_btn flex_layout">
                                    {t("Write")}
                                </div>
                            </Button>}
                            onClose={() => setWritePopState(-1)}
                            preferredAlignment="right"
                        >
                            <div onClick={(e) => {
                                e && e.stopPropagation();
                            }}>
                                <ActionList
                                    actionRole="menuitem"
                                    items={[
                                        {
                                            content: t("Generate Blog with SEOAnt AI"),
                                            icon: AIIcon,
                                            onAction: () => jumpCreateBlog(id, keyword, false)
                                        },
                                        // {
                                        //     content: t("Write yourself"),
                                        //     icon: BlogMajor,
                                        //     onAction: jumpCreateBlog
                                        // }
                                    ]}
                                />
                            </div>
                        </Popover>

                    }
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    // 分页
    const wwidth = window.innerWidth; // 屏幕宽度
    let footerContentMsg = "";
    if (total > 0) {
        const startNum = (page - 1) * size + 1;
        const endNum = page * size > total ? total : page * size;
        footerContentMsg = wwidth >= 550 ? <FooterPageSelect changePageSize={changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
    }

    // 列表
    const TopicTableList = <div className="topic_list" ref={listRef}>
        <Card padding={0}>
            <IndexFilters
                sortOptions={false}
                sortSelected={sortSelected}
                queryValue={queryValue}
                queryPlaceholder={t("Search keywords")}
                disabled={userLevel === 1}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={() => handleFiltersQueryChange("")}
                onSort={setSortSelected}
                primaryAction={false}
                cancelAction={{
                    onAction: onHandleCancel,
                    disabled: false,
                    loading: false,
                }}
                tabs={[]}
                selected={selected}
                onSelect={setSelected}
                canCreateNewView={false}
                onCreateNewView={onCreateNewView}
                filters={filters}
                appliedFilters={appliedFilters}
                onClearAll={handleFiltersClearAll}
                mode={mode}
                setMode={setMode}
                loading={listLoading}
            />
            <IndexTable
                loading={listLoading}
                resourceName={resourceName}
                itemCount={userLevel === 1 ? testRowData.length : tableData.length}
                selectedItemsCount={
                    allResourcesSelected ? "All" : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                headings={tableHeadings}
                promotedBulkActions={promotedBulkActions}
                selectable={userLevel !== 1}
                sortable={[false, true, true, true, false, false]}
                onSort={onSortColumnData}
            >
                {userLevel === 1 ? testRowData : rowKeywordData}
            </IndexTable>
            {
                userLevel === 1 && <div className="shade_pop">
                    <Button icon={LockMinor} onClick={() => show(1)}>{t("Upgrade to unlock")}</Button>
                </div>
            }
            {
                Boolean(userLevel !== 1 && tableData.length > 0) && <div className={`justify_center ${current_PageSize > 5 ? 'sticky_footer' : ''}`}>
                    <Pagination
                        label={footerContentMsg}
                        hasPrevious={hasPrevious}
                        onPrevious={() => changePageTable(page - 1)}
                        hasNext={hasNext}
                        onNext={() => changePageTable(page + 1)}
                    />
                </div>
            }
        </Card>
    </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终页面
    const pageContanier = <div className="keyword_pages">
        <BlockStack gap={400}>
            {domainBanner}
            {TipBanner}
            {PageTipBanner}
            {TopDataBlock}
            <BlockStack gap={200}>
                <div className="keyword_topic">
                    {/* <div className="tp_select">
                        <Popover
                            active={topicPopState}
                            activator={<p className="flex_layout" onClick={() => setTopicPopState(!topicPopState)}>{t("Topic")}: {t("All")} <Icon source={ChevronDownMinor} tone="base" /></p>}
                            onClose={() => setTopicPopState(false)}
                            preferredAlignment="left"
                        >
                            <Card padding={200}>
                                <div className="topic_data">
                                    {
                                        topicList.length > 0 ? topicList.map((item) => {
                                            return <div key={item.value} className={`topic_item ${item.id === topicSel.id ? 'topic_active' : ''}`} onClick={() => handleSelectTopic(item)}>
                                                <p className="Every_Card_Text">{item.title}</p>
                                                <span>{item.info}</span>
                                            </div>
                                        }) : <div>No datas found</div>
                                    }
                                </div>
                            </Card>
                        </Popover>
                        <span>
                            KD: {topicSel?.kd || '-'}&nbsp;&nbsp;SV: {topicSel?.sv || '-'}&nbsp;&nbsp;Covg: {topicSel?.Covg || '-'}
                        </span>
                    </div> */}
                    <div className="tp_opera">
                        <Popover
                            active={exportPopState}
                            activator={<Button icon={ExportMinor} loading={exportLoading} onClick={(e) => {
                                e && e.stopPropagation();
                                setExportPopState(!exportPopState);
                            }} disclosure>
                                <div className="export_opera flex_layout">
                                    {t("Export")}
                                </div>
                            </Button>}
                            onClose={() => setExportPopState(false)}
                            preferredAlignment="left"
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Export current keywords"),
                                        onAction: exportKeywordsData,
                                        disabled: tableData.length === 0
                                    },
                                    {
                                        content: t("Export history"),
                                        onAction: openExportHistory
                                    }
                                ]}
                            />
                        </Popover>
                        <Button variant="primary" onClick={() => jumpUrl("/keywordRearch/keywords-search")}>{t("Keywords Explore")}</Button>
                    </div>
                </div>
                {TopicTableList}
            </BlockStack>
        </BlockStack>
        {FooterHelpBox}
    </div>

    return <Page>
        <title>SEOAnt - Keywords</title>

        {pageContanier}
        {exportRecordsModal}
        {delSegmentsModal}
        {overchargeModal}
        {creditsBuyModal}
        {categoryManageModal}
        <AddToSegments
            type={"Keywords"}
            level={userLevel}
            openState={openState}
            keywordsSelData={keywordsSelData}
            toggleToast={toggleToast}
            show={show}
            handleCloseModal={handleCloseCreateModal}
            handleResetAll={handleResetAll}
            handleCallbackData={handleCallbackData}
        />
    </Page>
}


function disambiguateLabel(key, selectVal, arr) {
    if (selectVal.length === 0) return key;
    switch (key) {
        case 'Topic':
            let topicArr = arr.filter(i => selectVal.includes(i.value));
            let topicText = '';
            topicArr.forEach((t, i) => {
                topicText += i === topicArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Topic: ${topicText}`;
        case 'Covered':
            return `${t("Covered")}: ${t(selectVal[0])}`;
        case 'Segments':
            let segArr = arr.filter(i => selectVal.includes(i.value));
            let segText = '';
            segArr.forEach((t, i) => {
                segText += i === segArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Categories: ${segText}`;
        case 'Type':
            let typeArr = arr.filter(i => selectVal.includes(i.value));
            let typeText = '';
            typeArr.forEach((t, i) => {
                typeText += i === typeArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Type: ${typeText}`;
        default:
            return selectVal;
    }
}

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

// 单位转换
function formatNumber(num) {
    // 将数字转换为以K为单位
    return num >= 1000 ? (num / 1000).toFixed(1) + 'K' : num;
}

export default withRouter(KeywordsData);